import { render, staticRenderFns } from "./ProjectEdit.vue?vue&type=template&id=3ba1934b"
import script from "./ProjectEdit.vue?vue&type=script&lang=js"
export * from "./ProjectEdit.vue?vue&type=script&lang=js"
import style0 from "./ProjectEdit.vue?vue&type=style&index=0&id=3ba1934b&prod&media=screen&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports